import React, { useState, useEffect, useContext }  from 'react'
import './eswearing.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { useNavigate,Link , useParams  } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'
import { ShareContext } from '../../context/ShareContext'
import { Button } from '@mui/material'
import moment from 'moment'

function Eswearing() {
    const { profile } = useContext(ShareContext)
    var url=`${Constants.apiUrl}/gazette/eswearing/${profile.username}`
    const [docs, setDocs] = useState([]);
    const [cases, setCases]=useState([]);
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [casetype, setCaseType] = useState('litigation');

    const navigate = useNavigate();
    useEffect(() => {
        onLoad()
       
      }, []);


      const onLoad= async()=>{
        //for account registration
        setCaseType('litigation');
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const onLoadAdr= async()=>{
        setCaseType("adr");
        var url=`${Constants.apiUrl}/gazette/adr/eswearing/${profile.username}`
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const getTitle=(caseid)=>{
       var cc= cases.filter((c) => c.caseId ==caseid);
        if(cc.length==0)
         return 'N/A' 
        else
        return cc[0].caseTitle;
    }
    const getCaseNum=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else{
            var cnum=cc[0].caseNumber;
            var inf= cnum.indexOf('Temp');

           return inf==-1? cc[0].caseNumber:getCaseRef(caseid); 
         }
         
     } 
     
     const getCaseRef=(caseid)=>{
       
        var cc= refs?.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0]?.referenceNumber;
     }

     
     const onView=(item)=>{
            var a={...item,caseTitle: getTitle(item.caseId),caseNumber:getCaseNum(item.caseId), type:'user'   };
            if(item.doctumentType=='template'){
                navigate("/view-document-template", {state: {item:a}});
            }else{
                navigate("/view-document", {state: {item:a}});
            }
            
     }
   
  return (
    <div className='e-swearing'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div >
                        <h2>e-Swearing Schedule -{casetype=='litigation'?'Litigation Cases':casetype=='adr'?'ADR Cases':'Others'}</h2> 
                        <button className='planred' onClick={onLoad}>Litigation</button>
                        <button className='planred' onClick={onLoadAdr}>ADR Cases</button>
                    </div>
                    <p>View e-Swearing Meetings</p>
                </div>
                <p className="nav-status">Home/Specifications/e-Swearing-Schedule</p>
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            {/* <th>ID</th> */}
                            
                            <th>Suite Number</th>
                            <th> Title</th>
                            <th>Schedule Date and Time</th>
                            <th>Zoom Link</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { docs.map((item, id) => { return (
                            <tr key={id}>
                                {/* <td>{item.id}</td> */}
                                <td>{getCaseNum(item.caseId)}</td>
                                <td>{getTitle(item.caseId)}</td>
                                <td className={ item.schedule!=null ?'date-time' : 'date-time pends'}>{item.schedule!=null ? moment(item.schedule).format("dddd, MMMM Do YYYY h:mm a")  : 'No scheduled date'}</td>
                                <td className={item.schedule!=null ? 'zoom' : 'zoom pends'}>{item.zoomLink!=null && <a href={item.zoomLink} target='_blank'> Zoom Link </a>} </td>
                                <td className='view-doc'> <button className='black' onClick={()=>onView(item)}>View Documents Attached</button></td>
                               {item.caseFeeId==0 && <td className='view-doc'> <button className='red' onClick={()=>onView(item)}>Make Payment</button></td>} 
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => navigate('/dashboard') }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Home</p>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
    </div>
  )
}

export default Eswearing